export const desensitizePhone = (phone: string | undefined | null): string => {
  if (!phone || typeof phone !== 'string') {
    return ''
  }

  const phoneStr = phone.toString().trim()

  if (phoneStr.length !== 11) {
    return phoneStr
  }

  return phoneStr.slice(0, 3) + '****' + phoneStr.slice(7)
}
